import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleLabel: {
		id: 'servicedesk-premium-landing-page.title-label',
		defaultMessage: 'Jira Service Management',
		description: 'Title for the Premium landing page.',
	},
	subtitleLabel: {
		id: 'servicedesk-premium-landing-page.subtitle-label',
		defaultMessage: 'Some Jira Service Management Operations features will be moving to Premium.',
		description: 'Subtitle for the Premium landing page.',
	},
	tryItFreeButtonLabel: {
		id: 'servicedesk-premium-landing-page-trigger-banner.ui.try-it-free-button-label',
		defaultMessage: 'Try Premium for free',
		description: 'Label for the try it free button in the Premium landing page.',
	},
});
